import classes from "./Skill.module.css";
import TypeAnimation from "react-type-animation";

const Skill = () => {
  return (
    <div className="skill">
      <div className={classes.skills}>
        <TypeAnimation
          cursor={true}
          sequence={["My Skill", 3000, ""]}
          repeat={(3, Infinity)}
          wrapper="h2"
        />
        <div className={classes["skills-box"]}>
          <div className={classes.container}>
            <p>HTML5</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar1"]}></div>
            </div>
            <span>90 %</span>
          </div>
          <div className={classes.container}>
            <p>CSS3</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar2"]}></div>
            </div>
            <span>80 %</span>
          </div>
          <div className={classes.container}>
            <p>Javascript</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar3"]}></div>
            </div>
            <span>70 %</span>
          </div>
          <div className={classes.container}>
            <p>React Js</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar4"]}></div>
            </div>
            <span>70 %</span>
          </div>
          <div className={classes.container}>
            <p>Node Js</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar5"]}></div>
            </div>
            <span>60 %</span>
          </div>
          <div className={classes.container}>
            <p>Express JS</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar6"]}></div>
            </div>
            <span>70 %</span>
          </div>
          <div className={classes.container}>
            <p>MongoDB</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar7"]}></div>
            </div>
            <span>80 %</span>
          </div>
          <div className={classes.container}>
            <p>MY SQL</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar8"]}></div>
            </div>
            <span>90 %</span>
          </div>
          <div className={classes.container}>
            <p>Programming</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar9"]}></div>
            </div>
            <span>80 %</span>
          </div>
          <div className={classes.container}>
            <p>Coding</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar10"]}></div>
            </div>
            <span>90 %</span>
          </div>
          <div className={classes.container}>
            <p>Logic Building</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar11"]}></div>
            </div>
            <span>80 %</span>
          </div>
          <div className={classes.container}>
            <p>SDE</p>
            <div className={classes.progress}>
              <div className={classes["bar-bar12"]}></div>
            </div>
            <span>60 %</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Skill;
